import { ConnectionState } from '@d/sdk'

export function getItemStateColor(state: ConnectionState): string {
  switch (state) {
    case ConnectionState.CONNECTED:
      return 'success'
    case ConnectionState.AUTH_FAILURE: case ConnectionState.MISSING_PERMISSIONS:
      return 'warning'
    default:
      return 'error'
  }
}

export function getItemStateText(state: ConnectionState): string {
  switch (state) {
    case ConnectionState.CONNECTED:
      return 'success'
    case ConnectionState.AUTH_FAILURE:
      return 'auth'
    case ConnectionState.MISSING_PERMISSIONS:
      return 'missingPermissions'
    default:
      return 'server'
  }
}
